import React from 'react';
import Fleuron from '../components/Fleuron';

const AboutPage = () => (
  <div>
    <h1>Příběh</h1>
    <p>Píší příležitostní cestovatelé Martin, Luděk a Vojta.</p>
    <p>
      Počátek jejich společných cest se datuje do roku 2015, kdy se po 2 metrech piv rozhodli, že do
      roka a do dne vyrazí do Číny.
    </p>
    <p>
      Od té doby navštívili <a href="http://www.chinatrip.cz/">Hong Kong, Taiwan a východní Čínu</a>{' '}
      a&nbsp;nyní dobývají <strong>Spojené státy</strong>.
    </p>
    <Fleuron />
  </div>
);

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about.js